import { atom } from "recoil"

const medicationsAtom = atom({
    key: 'medications',
    default: {}
})

export default medicationsAtom